<p class="avenir-font d-flex justify-content-start align-items-center">
  <b>Filter By Last Verified</b> 
  <!-- <mat-icon class="text-muted ms-2" ngbPopover="Need text here..."
      triggers="mouseenter:mouseleave">info
    </mat-icon> -->
</p>

<div class="custom-slider ms-3 ps-2 pe-3">
  <ngx-slider class="w-100" [(value)]="sliderValue" [options]="sliderOptions" (valueChange)="onLastVerifiedChange()"></ngx-slider>
</div>
